import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = { class: "heading text-primary-black" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-content-end"
}

import { computed, ComputedRef } from 'vue'

  // Types
  import { BookingSummary } from '@/services/BookingService.interface'

  // Composables
  import { useBookingStatus } from '@/composables/useBookingStatus'

  // Components
  import Card from '@/components/UI/Card.vue'
  import PaymentConditionsList from './PaymentConditionsList.vue'
  import Totals from './Totals.vue'
  import PaymentButton from '@/components/common/PaymentButton.vue'
  import ReserveActionsButton from '@/components/common/ReserveActionsButton.vue'
  import { useBookingFunnelActions } from '@/composables/useBookingFunnelActions'
  import { useBookingFunnelNavigation } from '@/composables/useBookingFunnelNavigation'

  // Store
  import { useStore } from '@/store'
  import { useI18n } from 'vue-i18n'
  interface Props {
    booking: BookingSummary | null
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentSection',
  props: {
    booking: {}
  },
  setup(__props: any) {

  // Vue
  const store = useStore()

  // Translations
  const { t } = useI18n()

  // Props
  const props = __props

  // Computed
  const userId: ComputedRef<string | null> = computed(
    () => store.state.auth?.user?.iresa_id || null
  )

  // Calculate the net paid amount
  const totalPaid: ComputedRef<number> = computed(() => {
    if (props.booking) {
      const { sellingPrice, leftToPay } = props.booking
      return sellingPrice - leftToPay
    }
    return 0
  })

  const depositToPay: ComputedRef<number | null> = computed(() => {
    if (!props.booking || props.booking.depositMet) return null

    const remainingDeposit = Number(props.booking.depositRemainingCents)
    if (Number.isFinite(remainingDeposit) && remainingDeposit > 0) {
      return remainingDeposit
    }

    const initialDeposit = Number(props.booking.initialPaymentRequired)
    if (Number.isFinite(initialDeposit) && initialDeposit > 0) {
      return initialDeposit
    }

    return null
  })

  const { isQuoteOrCartInProgress } = useBookingStatus(props.booking)

  const { showPayBalanceButton } = useBookingFunnelActions(
    () => props.booking as BookingSummary
  )
  const { payActionLabel } = useBookingFunnelNavigation(
    () => props.booking as BookingSummary
  )

return (_ctx: any,_cache: any) => {
  return (_ctx.booking)
    ? (_openBlock(), _createBlock(Card, {
        key: 0,
        "additional-classes": "px-3"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('payments.title')), 1),
            _createVNode(PaymentConditionsList, {
              options: _ctx.booking.options,
              "lihe-id": _ctx.booking.liheId,
              "lihe-name": _ctx.booking.liheName,
              "package-code": _ctx.booking.packageCode
            }, null, 8, ["options", "lihe-id", "lihe-name", "package-code"]),
            _createVNode(Totals, {
              totalPrice: Number(_ctx.booking.sellingPrice),
              leftToPay: _ctx.booking.leftToPay,
              depositToPay: depositToPay.value,
              totalPaid: totalPaid.value,
              isQuoteOrCartInProgress: _unref(isQuoteOrCartInProgress)
            }, null, 8, ["totalPrice", "leftToPay", "depositToPay", "totalPaid", "isQuoteOrCartInProgress"]),
            (!_unref(isQuoteOrCartInProgress))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_unref(showPayBalanceButton))
                    ? (_openBlock(), _createBlock(ReserveActionsButton, {
                        key: 0,
                        booking: _ctx.booking,
                        "default-label": _unref(payActionLabel)
                      }, null, 8, ["booking", "default-label"]))
                    : (_openBlock(), _createBlock(PaymentButton, {
                        key: 1,
                        "user-id": userId.value,
                        booking: _ctx.booking
                      }, null, 8, ["user-id", "booking"]))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})